/** Level 4 (claude/level-4-source): the 20 book lessons in book order, plus the lettered lessons not in the book yet (extra.ts). */
import type { Lesson } from "../types";
import { L4_LESSON1, L4_LESSON2, L4_LESSON3, L4_LESSON4, L4_LESSON5, L4_LESSON6, L4_LESSON7 } from "./lesson01to07";
import * as B from "./lesson08to20";
import * as X from "./extra";

export const LEVEL4: Lesson[] = [
  L4_LESSON1, X.L4_LESSON1A, L4_LESSON2, L4_LESSON3, L4_LESSON4, X.L4_LESSON4A, X.L4_LESSON4B, L4_LESSON5, L4_LESSON6, L4_LESSON7,
  B.L4_LESSON8, B.L4_LESSON9, B.L4_LESSON10, B.L4_LESSON11, X.L4_LESSON11A, B.L4_LESSON12, X.L4_LESSON12A, X.L4_LESSON12B, B.L4_LESSON13, X.L4_LESSON13A, B.L4_LESSON14,
  B.L4_LESSON15, B.L4_LESSON16, B.L4_LESSON17, B.L4_LESSON18, X.L4_LESSON18A, X.L4_LESSON18B, B.L4_LESSON19, B.L4_LESSON20,
];
